/*
  Favori (kalp) ikonu - Fahhar
  -------------------------------------------------------------------------
  SWishlist uygulamasinin genis (26x22) kalp sembolunu, normal oranli (24x24)
  ince bir kalple degistirir. Uygulamanin calismasina dokunulmaz; yalnizca
  sprite icindeki sembolun icerigi degisir.

  Uygulama sprite'i bizden sonra yeniden yazabiliyor; bu yuzden kontrol
  isarete degil, sembolun icindeki yola (path) bakar ve gerektiginde yeniden
  uygular. Sembol bulunamazsa hicbir sey yapilmaz, uygulamanin kendi ikonu
  kalir.
  Boyut: assets/fk-favori.css
  Kalp yolu: Lucide ikon seti (ISC License).
*/
(function () {
  'use strict';

  var HEART = 'M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z';
  /* Dolu kalpte fill/stroke yazilmaz; uygulamanin kendi rengi miras alinir. */
  var OUTLINE = '<path d="' + HEART + '" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>';
  var FILLED = '<path d="' + HEART + '" stroke="none"></path>';

  var TARGETS = [
    { id: 'st_add_icon', html: OUTLINE },
    { id: 'st_added_icon', html: FILLED },
    { id: 'st_details_icon', html: OUTLINE }
  ];

  var applying = false;

  function apply() {
    if (applying) return false;
    applying = true;
    var found = 0;
    for (var i = 0; i < TARGETS.length; i++) {
      var symbol = document.getElementById(TARGETS[i].id);
      if (!symbol) continue;
      found++;
      var path = symbol.firstElementChild;
      if (!path || path.getAttribute('d') !== HEART) {
        symbol.setAttribute('viewBox', '0 0 24 24');
        symbol.innerHTML = TARGETS[i].html;
      }
    }
    applying = false;
    return found === TARGETS.length;
  }

  var watched = null;
  var spriteObserver = new MutationObserver(function () { apply(); });

  /* Sprite'i bulur, kalbi uygular ve sprite degisirse yeniden uygulamak
     uzere izlemeye alir. */
  function hook() {
    var sprite = document.getElementById('st_wishlist_icons');
    if (!sprite) return false;
    apply();
    if (watched !== sprite) {
      spriteObserver.disconnect();
      spriteObserver.observe(sprite, { childList: true, subtree: true, attributes: true });
      watched = sprite;
    }
    return true;
  }

  hook();

  /* Uygulama sprite'i gec enjekte edebilir veya yenileyebilir: ilk 60 saniye
     iki saniyede bir bakilir, sonra izleme yalnizca sprite uzerinden surer. */
  var tries = 0;
  var timer = setInterval(function () {
    hook();
    if (++tries >= 30) clearInterval(timer);
  }, 2000);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hook);
  }
  window.addEventListener('load', hook);
})();

(() => {
  'use strict';
  const turkish = document.documentElement.lang.toLowerCase().startsWith('tr');
  const setText = (selector, text) => document.querySelectorAll(selector).forEach(element => {
    if (element.textContent !== text) element.textContent = text;
  });
  const update = () => {
    const title = document.querySelector('h1.product__title');
    const heart = document.querySelector('.st-wishlist-button[data-type="details"]');
    if (title && heart) {
      let row = title.closest('.fk-product-title-row');
      if (!row) {
        row = document.createElement('div');
        row.className = 'fk-product-title-row';
        title.before(row);
        row.append(title);
      }
      if (heart.parentElement !== row) row.append(heart);
    }
    if (!turkish) return;
    document.querySelectorAll('.st-wishlist-button').forEach(button => {
      const label = button.classList.contains('st-is-loading') ? 'Favoriler güncelleniyor' : button.classList.contains('st-is-added') ? 'Favorilerden çıkar' : 'Favorilere ekle';
      if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      if (button.getAttribute('title') !== label) button.setAttribute('title', label);
      const pressed = String(button.classList.contains('st-is-added'));
      if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
    });
    document.querySelectorAll('.st-wishlist-details-button').forEach(button => {
      if (button.getAttribute('aria-label') !== 'Favori listemi aç') button.setAttribute('aria-label', 'Favori listemi aç');
      if (button.getAttribute('title') !== 'Favori listemi aç') button.setAttribute('title', 'Favori listemi aç');
    });
    setText('.st-wishlist-details_title .st-h3', 'Favori listem');
    setText('.st-wishlist-details_empty p:first-child b', 'Favorilerinizi burada biriktirin');
    setText('.st-wishlist-details_empty p:nth-child(2)', 'Beğendiğiniz ürünlerin kalbine dokunun; hepsi burada sizi beklesin.');
    setText('.st-wishlist-save-your-wishlist a', 'Favorilerinizi hesabınıza kaydetmek için giriş yapın');
  };
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; update(); });
  }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['class']});
  update();
})();
